export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11283.34b93bcd.jpg";